import React from 'react';
import { Spin } from 'antd';

interface LoadingProps {
  tip?: string;
  fullPage?: boolean;
}

/**
 * 统一加载状态组件
 * - 默认：居中 Spin + 提示文字
 * - fullPage=true：全屏居中 Spin
 */
const Loading: React.FC<LoadingProps> = ({ tip = '加载中...', fullPage = false }) => (
  <div
    style={{
      textAlign: 'center',
      padding: fullPage ? 80 : 40,
      ...(fullPage ? { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' } : {}),
    }}
  >
    <Spin tip={tip} size="large">
      <div style={{ padding: 50 }} />
    </Spin>
  </div>
);

export default Loading;
